import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useProduct } from 'api/useProduct';

import { Spinner } from 'components/ui/spinner';

import ProductsForm from '../ProductsForm/ProductsForm';
import { Product } from '../ProductsForm/ProductsForm.types';

import { ProductFormEditWrapperProps } from './ProductFormEditWrapper.types';

const ProductFormEditWrapper = ({
  dup = false,
  updateProduct,
  postProduct
}: ProductFormEditWrapperProps) => {
  const { id } = useParams();
  const { publisherId } = useParams();
  const product = useProduct(publisherId, id).getProduct;
  const updateMiddleware = (data: Product, onMutationComplete: () => void) => {
    if (!updateProduct) return;
    const form = {
      id,
      data
    };

    updateProduct(form as { id: string; data: Product }, onMutationComplete);
  };

  useEffect(() => {
    if (id && publisherId) {
      product.refetch();
    }
  }, [id, publisherId]);

  return (
    <>
      {product.isLoading ? (
        <Spinner className="absolute top-1/2 left-1/2 size-20" />
      ) : product.isError ? (
        <span>An error has occurred, {JSON.stringify(product.error)}</span>
      ) : (
        product.data && (
          <ProductsForm
            data={product.data.result}
            isLoading={product.isRefetching}
            emptyCache={product.remove}
            postProduct={dup ? postProduct : updateMiddleware}
            headline={dup ? 'New Product' : 'Edit Product'}
            buttonText={`${dup ? 'Save' : 'Update'} Product`}
            edit={dup ? false : true}
            dup={dup}
          />
        )
      )}
    </>
  );
};

export default ProductFormEditWrapper;
